import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey } from '../reducers/feature-key';
import { GenesysCloudIntegrationState } from '../genesys-cloud-integrations.state';

export const selectState = createFeatureSelector<GenesysCloudIntegrationState>(featureKey);

export const selectOrgPairingLoaded = createSelector(selectState, (state) => state.orgPairingLoaded);

export const selectHasOrgPairingIntegration = createSelector(selectState, (state) => state.hasOrgPairingIntegration);
